import { extractFromProseMirrorDoc } from "@shared/lib/card-stack/extracted"
import { parseCardStackProseMirrorJson } from "@shared/lib/card-stack/prose-mirror-utils"
import { legacyCardsFromCardStackDoc } from "@shared/lib/card-stack/unified-migration"
import type { ProseMirrorContent } from "@shared/models/card-stack"
import Patch from "@shared/models/patch-updater"

/**
 * Writes the doc together with the projections derived from it. A doc written alone leaves the
 * stack's standards, comment ids, and legacy cards describing content that is no longer there.
 * (LESSON_UNIFIED_INTERMEDIATE_UPDATE is the deliberate exception: it fires every 750ms mid-
 * keystroke, and the commit after it re-derives everything.)
 */
export function unifiedContentPatch(cardStackId: string, proseMirror: ProseMirrorContent): Patch {
  const doc = parseCardStackProseMirrorJson(proseMirror.json)

  return Patch.create("card-stack", cardStackId)
    .set("attributes.proseMirror", proseMirror)
    .set("attributes.extracted", extractFromProseMirrorDoc(doc))
    .set("attributes.cards", legacyCardsFromCardStackDoc(doc))
}
